/* eslint-disable no-console */
// CycleDayView.tsx
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import DayFirst from './dayFirst';
import DayZero from './dayZero';
import { CycleData } from '../../../components/Surgery/oocyteRetrieval/OocyteRetrival.helper';
import AllDay from './all-day';
import DayThird from './dayThird';
import DayTwo from './dayTwo';
import DayFour from './dayFour';
import { DropdownOption, mapDropdownOptions } from '../../../components/Medical_History_Forms/MenstrualHistory/MenstrualHistory.helpers';
import { fetchMasterData } from './dayFirst.helpers';

interface DayProps {
  dayIndex: number;
  selectedCycle: CycleData;
}

const CycleDayView: React.FC<DayProps> = ({ dayIndex, selectedCycle }) => {

  const [dropdownOptionsForEmbryo, setDropdownOptionsForEmbryo] = useState<{
    culture_dish_config: DropdownOption[];
    cleavage: DropdownOption[];
    embryoDetails_grade: DropdownOption[];
    fragmentation_percentage: DropdownOption[];
    number_of_cells: DropdownOption[];
    embryoDetails_multi_nuclei: DropdownOption[];
    pgtType: DropdownOption[];
    PGT_Facility: DropdownOption[];
    insemination_technique: DropdownOption[];
    embryoDetails_stage: DropdownOption[];
  }>({
    culture_dish_config: [],
    cleavage: [],
    embryoDetails_grade: [],
    fragmentation_percentage: [],
    number_of_cells: [],
    embryoDetails_multi_nuclei: [],
    pgtType: [],
    PGT_Facility: [],
    insemination_technique: [],
    embryoDetails_stage: []
  });

  // eslint-disable-next-line no-console
  useEffect(() => {
    console.log(selectedCycle);
  }, [selectedCycle]);

  useEffect(() => {
    fetchMasterData(
      '' // type wise not filtering from API
    )
      .then((response) => {
        setDropdownOptionsForEmbryo({
          culture_dish_config: mapDropdownOptions(response?.CULTURE_DISH_CONFIG),
          cleavage: mapDropdownOptions(response?.CLEAVAGE_CHOICES),
          embryoDetails_grade: mapDropdownOptions(response?.EMBRYO_GRADE),
          fragmentation_percentage: mapDropdownOptions(response?.FRAGMENTATION_CHOICES),
          number_of_cells: mapDropdownOptions(response?.NUMBER_OF_CELLS),
          embryoDetails_multi_nuclei: mapDropdownOptions(response?.MULTI_NUCLEI),
          pgtType: mapDropdownOptions(response?.PGT_TYPE),
          PGT_Facility: mapDropdownOptions(response?.PGT_FACILITY),
          insemination_technique: mapDropdownOptions(response?.INSEMINATION_TECHNIQUE),
          embryoDetails_stage: mapDropdownOptions(response?.EMBRYO_STAGE_CHOICES),

        });
      })
      .catch((err) => {

        console.error('Error fetching medical history masters', err);
      });
  }, []);
  console.log('dropdownOptionsForEmbryo',dropdownOptionsForEmbryo);

  const renderDayComponent = () => {
    switch (dayIndex) {
    case 1:
      return <DayZero initialCycleId={selectedCycle.id} dropDownMaster = {dropdownOptionsForEmbryo} />;
    case 2:
      return <DayFirst initialCycleId={selectedCycle.id} dropDownMaster = {dropdownOptionsForEmbryo} />;
    case 3:
      return <DayTwo initialCycleId={selectedCycle.id} dropDownMaster = {dropdownOptionsForEmbryo} />;
    case 4:
      return <DayThird initialCycleId={selectedCycle.id} dropDownMaster = {dropdownOptionsForEmbryo}/>;
    case 5:
      return <DayFour initialCycleId={selectedCycle.id} selectedDay={4} dropDownMaster = {dropdownOptionsForEmbryo} />;
    case 6:
      return <DayFour initialCycleId={selectedCycle.id} selectedDay={5} dropDownMaster = {dropdownOptionsForEmbryo} />;
    case 7:
      return <DayFour initialCycleId={selectedCycle.id} selectedDay={6} dropDownMaster = {dropdownOptionsForEmbryo} />;
    case 8:
      return <DayFour initialCycleId={selectedCycle.id} selectedDay={7} dropDownMaster = {dropdownOptionsForEmbryo}/>;
    default:
      return <AllDay selectedCycleId={selectedCycle.id} />;
    }
  };

  return (
    <Box>
      {renderDayComponent()}
    </Box>
  );
};

export default CycleDayView;
